<template>
  <div class="background-color-white full-height rounded-lg">
    <v-row no-gutters class="px-5 py-10">
      <v-col
        class="pb-5 pb-md-0"
        cols="12"
        :sm="getSMCols()"
        style="text-wrap: nowrap"
      >
        <div
          class="primary-color pb-3"
          :class="
            rewardsFormat
              ? 'font-weight-bold pl-10 pl-sm-15 pl-md-0 font-size-lg text-md-center text-lg-start'
              : 'font-weight-semibold text-center text-md-left'
          "
        >
          STORE HOURS
        </div>
        <div v-if="storeInfo" :class="{ 'font-size-sm': rewardsFormat }">
          <div v-for="(day, index) in $options.days" :key="index">
            <div v-if="storeInfo.store_info.hoursLtIso[day.key]">
              <div
                v-for="(iso, index) in storeInfo.store_info.hoursLtIso[day.key]"
                :key="index"
                class="align-center d-flex pb-1"
                :class="
                  rewardsFormat
                    ? 'justify-space-between justify-md-center justify-lg-space-between px-10 px-sm-15 px-md-0 font-weight-bold'
                    : 'justify-center justify-md-start'
                "
              >
                <span :class="{ 'font-weight-regular': rewardsFormat }"
                  >{{ day.name }}:</span
                >
                <span
                  >{{ formatTime(iso[0]) }} -
                  {{ formatTime(iso[1]) }}
                  <v-icon
                    class="ml-1"
                    v-if="hasHoursPastMidnight({ start: iso[0], end: iso[1] })"
                    small
                    >mdi-weather-night</v-icon
                  ></span
                >
              </div>
            </div>
            <div
              v-else
              class="text-center text-md-left pb-1"
              :class="
                rewardsFormat
                  ? 'justify-space-between d-flex px-10 px-sm-15 px-md-0 font-weight-bold'
                  : ''
              "
            >
              <span :class="{ 'font-weight-regular': rewardsFormat }"
                >{{ day.name }}:</span
              >
              <span>Closed</span>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="!rewardsFormat">
        <div
          class="primary-color font-weight-semibold pb-3 text-center text-md-left"
        >
          ONLINE ORDERING HOURS
        </div>
        <div v-for="(day, index) in $options.days" :key="index" class="pb-1">
          <div
            class="d-flex align-center justify-center justify-md-start"
            v-if="
              onlineOrderingHours &&
              onlineOrderingHours[day.key] &&
              onlineOrderingHours[day.key].hours
            "
          >
            {{ day.name }}:
            {{ onlineOrderingHours[day.key].hours.toString() }}
            <v-icon
              class="ml-1 font-size-sm"
              v-if="onlineOrderingHours[day.key].hoursPastMidnight"
              small
              >mdi-weather-night</v-icon
            >
          </div>
          <div v-else class="text-center text-md-left">
            {{ day.name }}: No Ordering Hours
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment-timezone";

export default {
  name: "StoreHours",
  computed: {
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
    onlineOrderingHours() {
      /*
      {{ day.name }}:
      {{ onlineOrderingHours[day.key].hours.toString() }}
      */
      if (
        !this.storeInfo ||
        !this.storeInfo.pickup_days ||
        !this.storeInfo.pickup_days.length
      ) {
        return;
      }
      const pickupDays = this.storeInfo.pickup_days;
      let onlineOrderingDays = {};
      let day = {};

      /*
        pickupDays is 7 days and the first day is soonest available day...maybe today.
        some days can be absent if the store is not receiving orders on that day.
      */

      pickupDays.forEach((pickupDay) => {
        // const dayIndex = new Date(pickupDay.date).getDay();
        const dayIndex = moment(pickupDay.date).day();

        if (onlineOrderingDays[this.$options.days[dayIndex].key]) {
          return;
        }
        switch (dayIndex) {
          case 0:
            day = {
              key: "Sun",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
            break;
          case 1:
            day = {
              key: "Mon",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
            break;
          case 2:
            day = {
              key: "Tue",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
            break;
          case 3:
            day = {
              key: "Wed",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
            break;
          case 4:
            day = {
              key: "Thu",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
            break;
          case 5:
            day = {
              key: "Fri",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
            break;
          default:
            day = {
              key: "Sat",
              hours: pickupDay.times[0],
              hoursPastMidnight: this.hasHoursPastMidnight(pickupDay.iso),
            };
        }
        onlineOrderingDays[day.key] = this.formatDay(day);
      });
      return onlineOrderingDays;
    },
  },
  days: [
    { key: "Sun", name: "Sunday" },
    { key: "Mon", name: "Monday" },
    { key: "Tue", name: "Tuesday" },
    { key: "Wed", name: "Wednesday" },
    { key: "Thu", name: "Thursday" },
    { key: "Fri", name: "Friday" },
    { key: "Sat", name: "Saturday" },
  ],
  methods: {
    formatDay({ hours, hoursPastMidnight }) {
      return {
        hours: hours.split("-").join(" - ").toUpperCase(),
        hoursPastMidnight,
      };
    },
    formatTime(iso) {
      return moment(iso).format("h:mm A");
    },
    hasHoursPastMidnight({ start, end }) {
      return moment(end).isAfter(start, "day");
    },
    getSMCols() {
      return this.rewardsFormat ? 12 : 6;
    },
  },
};
</script>

<style></style>
